import { makeImmutable } from "../../core";
import { ParameterSet } from "../ParameterSet";
export class NullParameterScope {
    constructor() {
        this.currentFulfillmentTimes = null;
        this.preorderTime = null;
        makeImmutable(this);
    }
    get parameterSet() {
        return ParameterSet.empty();
    }
}
